module.exports = __webpack_public_path__ + "static/media/lucky-wheel-img-1.294b4c96.png";